export default "__VITE_ASSET__uuJ6yFA$__"